import { DocumentNode, gql } from '@apollo/client';
import { Box, HStack, Link, StackProps, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { getCompanyJobTitle } from '@/utilities';

import { Header_CommentFragment } from './graphql-types/Header_CommentFragment';

import { DropdownMenu } from '../DropdownMenu';

export const Header: React.FC<
  {
    comment: Header_CommentFragment;
    onClickEdit: () => void;
  } & StackProps
> & {
  commentFragment: DocumentNode;
} = ({ comment, onClickEdit, ...stackProps }) => {
  return (
    <HStack {...stackProps}>
      <Box textStyle="compact" flex="1">
        <Link as={NextLink} href={`/members/${comment.author._id}`}>
          {comment.author.displayName}
        </Link>
        <Text color="gray.600" fontWeight="normal" noOfLines={1}>
          {getCompanyJobTitle(comment.author.company, comment.author.jobTitle)}
        </Text>
      </Box>
      {/* https://github.com/chakra-ui/chakra-ui/issues/3173 */}
      <Box>
        <DropdownMenu
          aria-label="more comment options"
          alignSelf="start"
          comment={comment}
          color="gray.700"
          onClickEdit={onClickEdit}
        />
      </Box>
    </HStack>
  );
};

Header.commentFragment = gql`
  fragment Header_CommentFragment on Comment {
    _id
    author {
      _id
      company
      jobTitle
      displayName
      proxyProfilePictureUrl(
        input: { w: 140, h: 140, fit: "facearea", facepad: 10.0 }
      )
    }
    ...DropdownMenu_CommentFragment
  }
  ${DropdownMenu.commentFragment}
`;
